module.exports = __webpack_public_path__ + "img/19.07ccf96a.png";